import { useRef } from "react";
import { motion, useMotionValue, useReducedMotion, useSpring, useTransform } from "framer-motion";

const SPRING = { stiffness: 150, damping: 18, mass: 0.4 };

/** Card that tilts toward the cursor in 3D and tracks a glare highlight. */
export const TiltCard = ({ children, className = "", max = 7, ...rest }) => {
    const ref = useRef(null);
    const reduce = useReducedMotion();
    const px = useMotionValue(0.5);
    const py = useMotionValue(0.5);

    const rotateX = useSpring(useTransform(py, [0, 1], [max, -max]), SPRING);
    const rotateY = useSpring(useTransform(px, [0, 1], [-max, max]), SPRING);

    const onMove = (e) => {
        if (reduce || !ref.current) return;
        const r = ref.current.getBoundingClientRect();
        px.set((e.clientX - r.left) / r.width);
        py.set((e.clientY - r.top) / r.height);
        ref.current.style.setProperty("--mx", `${e.clientX - r.left}px`);
        ref.current.style.setProperty("--my", `${e.clientY - r.top}px`);
    };

    const onLeave = () => {
        px.set(0.5);
        py.set(0.5);
    };

    return (
        <motion.div
            ref={ref}
            onMouseMove={onMove}
            onMouseLeave={onLeave}
            style={reduce ? undefined : { rotateX, rotateY, transformPerspective: 1100 }}
            className={`spotlight ${className}`}
            {...rest}
        >
            {children}
        </motion.div>
    );
};
